import { createContext, useContext } from "react";

const DeviceContext = createContext({
  isMobile: true,
});

export default DeviceContext;

export const useDeviceContext = () => useContext(DeviceContext);